<template>
  <div
      :id="id"
      class="v-nav-drawer d-flex flex-column flex-shrink-0 position-relative"
  >
    <v-nav-bar class=" h-100w-100 pt-0">
      <div class="side-menu-actions w-100">
        <button id="navbar-custom-toggler"
                class="btn btn-nav-toggle navbar-toggler hamburger hamburger--slider w-100 d-flex justify-content-center
                align-items-center border-0"
                type="button"
                @click="toggleCollapse(true)"
                :class="{'is-active': localValue}"
                aria-label="Abrir navegación">
          <span class="hamburger-box"><span class="hamburger-inner"></span></span>
          <span class="visually-hidden">Abrir navegación</span>
        </button>
      </div>

      <v-nav class="flex-column w-100 pt-8">
        <slot name="nav"/>
      </v-nav>
    </v-nav-bar>

    <div
        id="collapsableSubpanel"
        ref="collapse"
        class="collapse collapse-horizontal"
        :style="styles">
      <v-nav-bar id="collapsable-nav" class="py-0">
        <div class="side-menu-container w-100">
          <v-nav>
            <slot name="collapse"></slot>
          </v-nav>
        </div>
      </v-nav-bar>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VNavigationDrawer',
  emits: ['click', 'toggle', 'show', 'hide', 'hamburgerToggle'],
  props: {
    id: String,
    left: {
      type: String,
      default: '60',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapse: '',
      localValue: false,
    };
  },
  computed: {
    styles() {
      return {
        left: `${ this.left }px`,
      };
    },
  },
  mounted() {
    this.getInstance();
  },
  methods: {
    getInstance() {
      const element = this.$refs.collapse;

      if (!!this.value) {
        this.localValue = this.value;
      }

      if (element) {
        this.collapse = Collapse.getOrCreateInstance(element, { toggle: this.localValue });
      }
    },
    toggleCollapse(isHamburger) {
      this.collapse.toggle();

      this.localValue = !this.localValue;

      this.$emit('click');
      this.$emit('toggle', this.localValue);

      if (this.localValue) {
        this.$emit('show', this.localValue);
      } else {
        this.$emit('hide', this.localValue);
      }

      if (isHamburger) {
        this.$emit('hamburgerToggle');
      }
    },
    show() {
      this.collapse.show();

      this.localValue = true;

      this.$emit('toggle', this.localValue);
      this.$emit('show', this.localValue);
    },
    hide() {
      this.collapse.hide();

      this.localValue = false;

      this.$emit('toggle', this.localValue);
      this.$emit('hide', this.localValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VNavigationDrawer";
</style>

<style lang="scss">
.v-nav-drawer .nav .nav-item .nav-link.active > span:not(.mi) {
  font-weight: 600;
}
</style>
